import AbstractPage from './AbstractPage';
import { Swiper, Navigation, Lazy } from '../../../node_modules/swiper/dist/js/swiper.esm.js';
import * as Player from '@vimeo/player/dist/player.js';

Swiper.use([Navigation, Lazy]);

export default class Watch extends AbstractPage {
  declareProperties() {
    this.galleries = [...document.querySelectorAll('.swiper-container')];
    this.items = [...document.querySelectorAll('.ps-media__embed-repeated-item')];
    this.closeButtons = [...document.querySelectorAll('.gallery-container__close')];
    this.gallery = document.querySelector('.gallery-container');
    this.slider = null;
  }

  init() {
    this.initGallery();
    this.closeLightBox();
    this.openLightBox();
  }

  initGallery() {
    let _this = this;
    this.galleries.forEach(e => {
      new Swiper(e, {
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        on: {
          init: function () {
            _this.slider = this;
          },
          slideChangeTransitionStart: function () {
            this.slides.each((i, el) => {
              let player = new Player(el.querySelector('iframe'));
              player.pause();
            });
          },
          slideChangeTransitionEnd: function () {
            let player = new Player(this.slides[this.activeIndex].querySelector('iframe'));
            player.play();
          },
        },
      });
    });
  }

  openLightBox() {
    this.items.forEach(el => {
      el.addEventListener('click', e => {
        const el = e.target.parentNode;
        const elIndex = parseInt(el.dataset.index, 10);

        let slider = this.gallery.querySelector('.swiper-container').swiper;

        slider.slideTo(elIndex, 0);
        this.gallery.classList.add('show');

        let player = new Player(this.slider.slides[this.slider.activeIndex].querySelector('iframe'));
        player.play();
      });
    });
  }

  closeLightBox() {
    this.closeButtons.forEach(el => {
      el.addEventListener('click', e => {
        e.target.closest('.gallery-container').classList.remove('show');
        let player = new Player(this.slider.slides[this.slider.activeIndex].querySelector('iframe'));
        player.pause();
      });
    });
  }
}
